import { IContent } from '../../../common/interfaces/Content.interface';
import { IContentWithContextType } from '../../../common/interfaces/ContentWithContextType';
import { IMedia } from '../../../common/interfaces/Media.interface';
import { IQuestion } from '../../../common/interfaces/Question.interface';

// Helper function to process contentState
export const processContentState = (
  contentState: IContentWithContextType
): IContent => {
  const processedContent = { ...contentState };

  if (Array.isArray(contentState?.questions)) {
    processedContent.questions = contentState?.questions?.map(
      (q: IQuestion) => q.id
    ) as unknown as IQuestion[];
  } else {
    processedContent.questions = contentState?.questions?.id
      ? ([contentState?.questions?.id] as unknown as IQuestion[])
      : ([] as IQuestion[]);
  }

  processedContent.media = (contentState?.media?.id ||
    null) as unknown as IMedia;

  delete processedContent.contextType;

  return processedContent;
};
